import { gql } from '@apollo/client';
import { ErrorMessageInfo } from '@retainerclub/shared-api';

export default gql`
  mutation updateContactSettings($input: ContactSettingsUpdateInput!) {
    updateContactSettings(input: $input) {
      clientMutationId
      errorMessages {
        ...ErrorMessageInfo
      }
      contactSettings {
        id
        acceptSms
        acceptMarketing
        acceptSmsAt
        acceptMarketingAt
      }
    }
  }
  ${ErrorMessageInfo}
`;
